import React, { useState, useEffect } from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import UsersConfig from "./UsersConfig";
import GroupsConfig from "./GroupsConfig";
import SharingDetails from "./SharingDetails";
import IntlMessages from "../../../../../../util/IntlMessages";
import { Modal } from "../../../../../BP2Components";
import { getBoard } from "../../../../../../services/restAPI/RestApi";
import { Icon_DeploymentUnit, Icon_User } from "../../../../../BP2Components/Icons/icons";
import "./ShareBoardModal.less";

const ShareBoardModal = ({ boardInfo, visible, handleExit }) => {
   const intl = useIntl();
   const [shareOption, setShareOption] = useState();
   const [details, setDetails] = useState();
   const [detailsLoading, setDetailsLoading] = useState(false);

   const handleCancel = () => {
      handleExit();
      setShareOption();
   };

   useEffect(() => {
      if (visible && !shareOption) {
         setDetailsLoading(true);
         getBoard(boardInfo.id).then((response) => {
            const membersInfo = response.data.members?.map((member) => ({
               id: member.id,
               name: member.member.firstName + " " + member.member.lastName,
               showInMainNav: member.showInMainNav,
               permission: member.memberType,
               type: "users"
            }));
            const groupsInfo = response.data.boardGroups?.map((group) => ({
               id: group?.id,
               name: group?.group?.name,
               showInMainNav: group?.showInMainNav,
               permission: group?.memberType,
               type: "groups"
            }));
            setDetails(membersInfo.concat(groupsInfo));
            setDetailsLoading(false);
         });
      }
   }, [shareOption, visible]);

   return (
      <Modal
         isOpen={visible}
         onCancel={handleCancel}
         topBarContent={intl.formatMessage({ id: "boardsManager.shareBoard" })}
         bodyStyles={{ overflowX: "scroll" }}
         className="sharing-board-modal"
      >
         {!shareOption && (
            <ul className="share-options">
               <li
                  className="share-options__single"
                  id="users"
                  onClick={() => setShareOption("users")}
               >
                  <Icon_User />
                  <IntlMessages id="boardsManager.users" />
               </li>
               <li
                  className="share-options__single"
                  id="groups"
                  onClick={() => setShareOption("groups")}
               >
                  <Icon_DeploymentUnit/>
                  <IntlMessages id="boardsManager.groups" />
               </li>
               <li className="groups-table table">
                  <SharingDetails
                     dataSource={details}
                     setShareOption={setShareOption}
                     detailsLoading={detailsLoading}
                  />
               </li>
            </ul>
         )}

         {shareOption === "users" && (
            <UsersConfig boardInfo={boardInfo} setShareOption={setShareOption} />
         )}
         {shareOption === "groups" && (
            <GroupsConfig boardInfo={boardInfo} setShareOption={setShareOption} />
         )}
      </Modal>
   );
};

ShareBoardModal.propTypes = {
   boardInfo: PropTypes.object.isRequired,
   visible: PropTypes.bool.isRequired,
   handleExit: PropTypes.func.isRequired
};

export default ShareBoardModal;
